import type { ReactNode } from "react";
import clsx from "clsx";

export interface SegmentedOption<T extends string> {
  value: T;
  label: ReactNode;
}

export function SegmentedControl<T extends string>({
  value,
  onChange,
  options,
  name,
  size = "sm",
  className,
  disabled,
}: {
  value: T;
  onChange: (value: T) => void;
  options: SegmentedOption<T>[];
  name?: string;
  size?: "sm" | "md";
  className?: string;
  disabled?: boolean;
}) {
  return (
    <div
      className={clsx("eh-segmented", size === "md" && "eh-segmented--md", className)}
      role="radiogroup"
      aria-label={name}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled}
            className={clsx("eh-segmented-item", active && "is-active")}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
